export enum RmOccupancyEnum {
    OCCUPIED = "Occupied",
    OCCUPIED_NR = "Occupied-NR",
    RESERVED = "Reserved",
    NOT_OCCUPIED= "Not Occupied",
    PARTIALLY_OCCUPIED= "Partially Occupied"
}